import { StakeCardFrontSide } from "../../Assets/Images";
import PrimaryButton from "./primary-button";

function CardPair() {
  return (
    <div className="ir-card-pair" aria-hidden="true">
      <img className="ir-plastic ir-plastic-back" src={StakeCardFrontSide} alt="" />
      <img className="ir-plastic ir-plastic-front" src={StakeCardFrontSide} alt="" />
    </div>
  );
}

export default function StatusPanel({ title, body, actionLabel, onAction, secondaryLabel, onSecondary, showCards = true, footnote = null }) {
  const hasActions = Boolean(actionLabel || secondaryLabel);
  return (
    <section className="ir-status-panel">
      <div className="ir-status-body">
        <h1>{title}</h1>
        <p>{body}</p>
        {footnote ? <p className="ir-status-footnote">{footnote}</p> : null}
        {showCards ? <CardPair /> : <div className="ir-status-spacer" />}
      </div>
      {hasActions ? (
        <div className="ir-status-actions">
          {actionLabel ? <PrimaryButton onClick={onAction}>{actionLabel}</PrimaryButton> : null}
          {secondaryLabel ? (
            <button className="ir-text-btn" type="button" onClick={onSecondary}>
              {secondaryLabel}
            </button>
          ) : null}
        </div>
      ) : null}
    </section>
  );
}
